import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://a7e7fd1a7b66bc494e53b5fe7eefa96e@o133996.ingest.us.sentry.io/4508535628627968",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});